export const domesticMapping = {
	gender: {
		items: [
			{ id: 'IRlYE6j', filter: 'filtered' }, { id: 'IRmZN0R', filter: 'filtered' },
		],
		display: 'Gender',
	},
	age: {
		items: [
			{ id: 'IRn56m5', filter: 'filtered' }, { id: 'IRo2XnY', filter: 'filtered' },
		],
		display: 'Age',
	},
	clergyStatus: {
		items: [
			{ id: 'IRpYLoQ', filter: 'filtered', hideWhenSelectedDio: true }, { id: 'IRqxLp7', filter: 'filtered', hideWhenSelectedDio: true }, { id: 'IRJ6WKg', filter: 'filtered', showOnSelectedDio: true },
		],
		display: 'Clerical Orders',
	},
	compRanges: {
		items: [
			{ id: 'IRrkVq2', filter: 'filtered' },
		],
		display: 'Compensation Range',
	},
	creditedService: {
		items: [
			{ id: 'IRv2Lx8', filter: 'filtered' }, { id: 'IRwp7yr', filter: 'filtered' },
		],
		display: 'Credited Service',
	},
	positions: {
		items: [
			{ id: 'IRgJMDk', filter: 'filtered' }, { id: 'IRjR6gv', filter: 'filtered' },
		],
		display: 'Position',
	},
	churchSizeAsa: {
		items: [
			{ id: 'IRkRXj6', filter: 'filtered' }, { id: 'IRlYEkM', filter: 'filtered' },
		],
		display: 'Average Sunday Attendance (ASA)',
	},
	churchSizeOp: {
		items: [
			{ id: 'IRmZN0G', filter: 'filtered' }, { id: 'IRn56m7', filter: 'filtered' },
		],
		display: 'Operating Revenue',
	},
	province: {
		items: [
			{ id: 'IRo2XnX', filter: 'unfiltered' }, { id: 'IRpYLoV', filter: 'unfiltered' },
		],
		display: 'Province',
	},
	diocese: {
		items: [
			{ id: 'IRqxLpp', filter: 'filtered' }, { id: 'IRrkVqp', filter: 'filtered' },
		],
		display: 'Diocese',
	},
	genderIdentity: {
		items: [
			{ id: 'IRwp7y8', filter: 'filtered' }, { id: 'IRxkLzB', filter: 'filtered' },
		],
		display: 'Gender Identity',
	},
	raceEthnicity: {
		items: [
			{ id: 'IRyP2An', filter: 'filtered' }, { id: 'IRzpY4y', filter: 'filtered' },
		],
		display: 'Race/Ethnicity',
	},
	sexualOrientation: {
		items: [
			{ id: 'IRADKXl', filter: 'filtered' }, { id: 'IRBB9XY', filter: 'filtered' },
		],
		display: 'Sexual Orientation',
	},
};

export const internationalMapping = {
	gender: {
		items: [
			{ id: 'IRlYE6j', filter: 'filtered' },
		],
		display: 'Gender',
	},
	age: {
		items: [
			{ id: 'IRn56m5', filter: 'filtered' },
		],
		display: 'Age',
	},
	clergyStatus: {
		items: [
			{ id: 'IRpYLoQ', filter: 'filtered' },
		],
		display: 'Clerical Orders',
	},

	creditedService: {
		items: [
			{ id: 'IRv2Lx8', filter: 'filtered' },
		],
		display: 'Credited Service',
	},
	genderIdentity: {
		items: [
			{ id: 'IRwp7y8', filter: 'filtered' },
		],
		display: 'Gender Identity',
	},
	raceEthnicity: {
		items: [
			{ id: 'IRyP2An', filter: 'filtered' },
		],
		display: 'Race/Ethnicity',
	},
	sexualOrientation: {
		items: [
			{ id: 'IRADKXl', filter: 'filtered' },
		],
		display: 'Sexual Orientation',
	},
};